import { mapToUserQuicklinkGroupMappings } from "../../helpers/GlobalMapper";
import { UserQuicklinkGroupMapping } from "../../models/UserQuicklinkGroupMapping";
const API_URL = process.env.REACT_APP_API_URL;

export const fetchUserGroupQuickLinkGroupMapping = async (
  accessToken: string,
  groupId?: number,
  tenantID?: number
): Promise<UserQuicklinkGroupMapping[]> => {
  try {
    const params = new URLSearchParams();
    if (groupId) params.append("userGroupId", groupId.toString());
    if (tenantID) params.append("tenantID", tenantID.toString());

    let url = `${API_URL}${process.env.REACT_APP_USER_QUICKLINK_GROUPS_GET_MAPPING}`;
    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch Quick Link Group Mapping.");
    }

    const rawData = await response.json();
    return mapToUserQuicklinkGroupMappings(rawData); // Mapping applied here
  } catch (error) {
    console.error("Error in fetchUserGroupQuickLinkGroupMapping:", error);
    throw error;
  }
};


/**
 * Update quick links group mapping.
 * @param {string} accessToken - The user's access token.
 * @param {string} groupId - The user group ID.
 * @param {Array<string>} selectedLinkGroupsDetails - An array of quick link group IDs.
 * @param {number} [tenantID] - The tenant ID (optional).
 * @returns {Promise<void>} - Resolves if successful.
 */
export const updateQuickLinksGroupMapping = async (
  accessToken: string, 
  groupId: number, 
  selectedLinkGroupsDetails: Array<number>, 
  tenantID?: number,
  createdBy?: number
) => { 
  try {
    const params = new URLSearchParams();
    params.append("userGroupId", groupId.toString());

    selectedLinkGroupsDetails.forEach((id) =>
      params.append("quickLinkGroupId", id.toString())
    );

    if (tenantID !== undefined) {
      params.append("tenantID", tenantID.toString());
    }

    if (createdBy !== undefined) {
      params.append("createdBy", createdBy.toString());
    }

    const apiUrl = `${API_URL}${process.env.REACT_APP_USER_QUICKLINK_GROUPS_UPDATE_MAPPING}?${params.toString()}`;

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to update quick links group mapping.");
    }
  } catch (error) {
    throw error;
  }
};

